import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11 7.36526C12.1046 7.36526 13 8.26069 13 9.36526V13.3653C13 14.4699 12.1046 15.3653 11 15.3653H5C3.89543 15.3653 3 14.4699 3 13.3653V9.36526C3 8.26069 3.89543 7.36526 5 7.36526H6.5H11ZM8 9.36526C7.17157 9.36526 6.5 10.0368 6.5 10.8653C6.5 11.6937 7.17157 12.3653 8 12.3653C8.82843 12.3653 9.5 11.6937 9.5 10.8653C9.5 10.0368 8.82843 9.36526 8 9.36526ZM8 1.36526C9.65685 1.36526 11 2.70841 11 4.36526V6.36526H9.5V4.36526C9.5 3.53683 8.82843 2.86526 8 2.86526C7.17157 2.86526 6.5 3.53683 6.5 4.36526V6.36526H5V4.36526C5 2.70841 6.34315 1.36526 8 1.36526Z"
		/>
	</svg>
))
